module.exports = __webpack_public_path__ + "assets/img/wall-big.80044542.svg";